import React from 'react'
import { AgTechClickEventHandler, AgTechButtonProps, AgTechButton } from '@agtech/web/components/Buttons/AgTechButtons';
import AgTechActionPane from '@agtech/web/components/Headers/AgTechActionPane';
import AgTechViewDialog from '@agtech/web/components/Portals/Dialogs/AgTechViewDialog';
import { useAgTechQuery } from '@agtech/core/data/queries/AgTechDataQueries';
import { IndexLength } from '@agtech/core/utilities/AgTechUtilities';
import { AgTechContact } from '@agtech/data/contacts/ContactData';
import { ContactDataGetAllContactsQuery } from '@agtech/data/contacts/ContactDataQueries';
import ContactDialog from './ContactDialog';
import ContactMasterDetailPage from '../pages/ContactMasterDetailPage';
import ContactImportModal from '../../../../features/imports/integrations/ContactImportModal';

const ContactMasterDetailViewDialog = (props: {
    contactDetailPage?: (contact: AgTechContact) => JSX.Element,
    contactActionMenu?: (contact: AgTechContact) => JSX.Element
}) => {
    const contactsQuery = useAgTechQuery({
        query: ContactDataGetAllContactsQuery
    });

    return (
        <AgTechViewDialog
            data={{
                query: contactsQuery
            }}
            structure={{
                header: (contacts) => ({
                    header: `My Contacts (${IndexLength(contacts)})`,
                    detail: "Below is a list of all contacts for this operation, as well as details for each contact",
                    settings: {
                        content: {
                            body: () => (
                                <AgTechActionPane
                                    elements={[
                                        <ContactDialog.Button
                                            text='Create Contact'
                                            classes='button-highlight'
                                        />,
                                        <ContactImportModal.Button
                                            classes='button-highlight'
                                        />
                                    ]}
                                />
                            )
                        }
                    }
                }),
                body: {
                    classes: 'flex-column'
                },
                width: "90%"
            }}
        >
            {(contacts) => (
                <ContactMasterDetailPage 
                    contactDetailPage={props.contactDetailPage}
                    contactActionMenu={props.contactActionMenu}
                />
            )}
        </AgTechViewDialog>
    )
}

ContactMasterDetailViewDialog.ButtonProps = {
    text: 'Manage Contacts',
    icon: 'address-book',
    action: (e: AgTechClickEventHandler) => e.dialogs.openDialog({
        dialog: () => <ContactMasterDetailViewDialog />
    })
}

ContactMasterDetailViewDialog.Button = (props: AgTechButtonProps) => {
    return (
        <AgTechButton
            {...ContactMasterDetailViewDialog.ButtonProps}
            {...props}
        />
    )
}

export default ContactMasterDetailViewDialog;